import { VisuallyHidden } from '@bookjane2/bookjane-design-library';
import { useTranslation } from 'react-i18next';
import { SkipToContentPill, SkipToContentWrapper } from './SkipToContent.styled';

export const SkipToContent = () => {
  const { t } = useTranslation();
  return (
    <SkipToContentWrapper>
      <VisuallyHidden as="a" focusable href="#main-content" style={{ borderRadius: '6px' }}>
        <SkipToContentPill>{t('navigation:SKIP_TO_MAIN_CONTENT')}</SkipToContentPill>
      </VisuallyHidden>
    </SkipToContentWrapper>
  );
};
